module.exports = __webpack_public_path__ + "static/img/city-4317139_1920.1d4a950.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/city-4317139_1920.jpg
// module id = 95Ex
// module chunks = 1